module.exports = __webpack_public_path__ + "stack-warning.svg";